import { Outlet, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { useLang } from '../context/LangContext';
import LanguagePicker from '../components/LanguagePicker';
import AdminSidebar from '../admin/components/AdminSidebar';

export default function AdminLayout() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { signOut } = useAuth();
  const { lang, setLang } = useLang();

  async function handleLogout() {
    await signOut();
    navigate('/admin/login', { replace: true });
  }

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="flex flex-1 flex-col">
        <header className="admin-header">
          <span className="admin-header__title">{t('admin.title')}</span>
          <div className="admin-header__actions">
            <LanguagePicker currentLang={lang} onChange={setLang} />
            <button type="button" onClick={handleLogout} className="admin-header__logout">
              {t('admin.logout')}
            </button>
          </div>
        </header>
        <main className="admin-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
